import { render, staticRenderFns } from "./RiskMonitoring.vue?vue&type=template&id=943477c0&scoped=true&"
import script from "./RiskMonitoring.vue?vue&type=script&lang=js&"
export * from "./RiskMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./RiskMonitoring.vue?vue&type=style&index=0&id=943477c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943477c0",
  null
  
)

export default component.exports